<template>
    <div>
        <rkm-row>
            <rkm-col cols="2">
                <rkm-form-select
                    :options="data.form.saudeBucal.odontogramas"
                    default-option-text="Atual"
                    label="Período"
                    show-default-option
                    text-field="data"
                    v-model="data.model.saudeBucal.odontograma.id"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="auto">
                <rkm-form-radio-group
                    :disabled="!!data.model.saudeBucal.odontograma.id"
                    label="Possui aparelho"
                    v-model="data.model.saudeBucal.odontograma.possuiAparelho"
                >
                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-form-radio-group
                    :disabled="!!data.model.saudeBucal.odontograma.id"
                    label="Possui contenção"
                    v-model="data.model.saudeBucal.odontograma.possuiContencao"
                >
                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-form-checkbox-group
                    :disabled="!!data.model.saudeBucal.odontograma.id"
                    :options="data.form.saudeBucal.odontograma.protesesTotais"
                    @change="handleProtesesTotaisChange"
                    label="Prótese"
                    v-model="data.model.saudeBucal.odontograma.protesesTotais"
                />
            </rkm-col>
        </rkm-row>

        <rkm-tabs>
            <rkm-tab title="Dentes">
                <rkm-row>
                    <rkm-col cols="auto">
                        <rkm-form-radio-group
                            @change="handleMostrarDentesDeciduosChange"
                            label="Mostrar dentes decíduos"
                            v-model="data.model.saudeBucal.odontograma.mostrarDentesDeciduos"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>

                <BoxDente :data="data" />

                <BoxDenteSupranumerario
                    v-if="!data.model.saudeBucal.odontograma.id"
                    :data="data"
                    class="mt-2"
                />
            </rkm-tab>

            <rkm-tab
                v-if="!data.model.saudeBucal.odontograma.id"
                title="Arcadas"
            >
                <BoxArcada :data="data" />
            </rkm-tab>
        </rkm-tabs>

        <rkm-area
            v-if="!!data.model.saudeBucal.odontograma.id"
            background-color="primary"
            title="Histórico de evoluções"
            type="box"
        >
            <rkm-list
                :items="data.form.saudeBucal.procedimentos"
                hide-filters
                hide-pagination
                item-cursor="default"
            >
                <template v-slot="{item}">
                    <rkm-row>
                        <rkm-col>
                            <strong>Data / Hora</strong><br />{{item.dataHora}}
                        </rkm-col>

                        <rkm-col>
                            <strong>Setor</strong><br />{{item.centroCusto.setor.nome}}
                        </rkm-col>

                        <rkm-col>
                            <strong>Profissional</strong><br />{{item.lotacao.profissional.nome}} - {{item.lotacao.ocupacao.nome}}
                        </rkm-col>
                    </rkm-row>

                    <hr />

                    <rkm-row>
                        <rkm-col cols="2">
                            <strong>Local</strong><br />{{item.local}}
                        </rkm-col>

                        <rkm-col cols="10">
                            <strong>Procedimentos</strong><br />

                            <div
                                v-for="(procedimento, index) in item.procedimentos"
                                :key="index"
                            >
                                {{procedimento.descricao}}, <strong>Quantidade: </strong>{{procedimento.quantidade}}
                            </div>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <strong>Observações</strong><br />{{item.observacao ? item.observacao : '-'}}
                        </rkm-col>
                    </rkm-row>
                </template>
            </rkm-list>
        </rkm-area>
    </div>
</template>

<script>
// Components.
import BoxArcada from './components/arcada/Index'
import BoxDente from './components/dente/Index'
import BoxDenteSupranumerario from './components/dente-supranumerario/Index'

// Mixins.
import {object} from '@/mixins'

export default {
    components: {
        BoxArcada,
        BoxDente,
        BoxDenteSupranumerario,
    },
    data: () => ({
        fields: [
            {key: 'local', label: 'Local', sortable: true},
            {key: 'procedimentos', label: 'Procedimentos', sortable: true},
        ],
    }),
    methods: {
        handleProtesesTotaisChange(value) {
            const defaultObject = {
                fragmentos: {
                    centro: {isTratado: null},
                    cima: {isTratado: null},
                    baixo: {isTratado: null},
                    direita: {isTratado: null},
                    esquerda: {isTratado: null},
                },
                problemasCondicoes: [],
            }

            if (value.includes('superior')) {
                this.getArcadas().superior.dentes.permanentes.map(dente => Object.assign(dente, this.clone(defaultObject)))
                this.getArcadas().superior.dentes.deciduos.map(dente => Object.assign(dente, this.clone(defaultObject)))
            }

            if (value.includes('inferior')) {
                this.getArcadas().inferior.dentes.deciduos.map(dente => Object.assign(dente, this.clone(defaultObject)))
                this.getArcadas().inferior.dentes.permanentes.map(dente => Object.assign(dente, this.clone(defaultObject)))
            }
        },
        handleMostrarDentesDeciduosChange() {
            const defaultObject = {
                fragmentos: {
                    centro: {isTratado: null},
                    cima: {isTratado: null},
                    baixo: {isTratado: null},
                    direita: {isTratado: null},
                    esquerda: {isTratado: null},
                },
                problemasCondicoes: [],
                procedimentos: [],
                observacao: null,
            }

            this.getArcadas().superior.dentes.deciduos.map(dente => Object.assign(dente, this.clone(defaultObject)))
            this.getArcadas().inferior.dentes.deciduos.map(dente => Object.assign(dente, this.clone(defaultObject)))
        },
        getArcadas() {
            return this.data.model.saudeBucal.odontograma.arcadas
        },
    },
    mixins: [object],
    props: {
        data: {type: Object, required: true},
    },
}
</script>